import {setupBasicSuggestSelect} from '../../../common/suggests';

// 個人設定
$(() => {
    // 請求元口座情報å
    if (document.getElementById('agent-regist-profile') != null) {

        setupBasicSuggestSelect('.js-bank-name', '/agent/findBank', '銀行名を入力', null, null, null);
        $('.js-bank-name').on('change', function(e) {
            let selectedBank = $('.js-bank-name option:selected').val();
            if (isNaN(selectedBank)) {
                selectedBank = '';
            }
            $('.bank-code').text(selectedBank);
            $('.js-branch-name').val(null).trigger('change');
        });
        setupBasicSuggestSelect('.js-branch-name', '/agent/findBranch', '支店名を入力', branchParamaterFilter, null, null);
        $('.js-branch-name').on('change', function(e) {
            let selectedBranch = $('.js-branch-name option:selected').val();
            if (isNaN(selectedBranch)) {
                selectedBranch = '';
            }
            $('.branch-code').text(selectedBranch);
        });

        $('input[name=business_type]').on('change',function() {
            let business_type = $('input[name="business_type"]:checked').val();
            if (business_type == 0) {
                $('#js-corporation-area').hide();
            } else {
                $('#js-corporation-area').show();
            }
        });
        choiceBusinessType();
    }
});

// 口座の種類初期判断
function choiceBusinessType() {
    let business_type = $('input[name="business_type"]:checked').val();
    if (business_type == 1) {
        $('#js-corporation-area').show();
    }
}

// 支店名用パラメータフィルター
function branchParamaterFilter(params) {
    let selectedBank = $('.js-bank-name option:selected').val();
    let query = {
        search: params.term,
        code: selectedBank,
    };
    return query;
}
